import { render, staticRenderFns } from "./data-capture-forms.vue?vue&type=template&id=74323b55&scoped=true&"
import script from "./data-capture-forms.vue?vue&type=script&lang=js&"
export * from "./data-capture-forms.vue?vue&type=script&lang=js&"
import style0 from "./data-capture-forms.vue?vue&type=style&index=0&id=74323b55&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74323b55",
  null
  
)

component.options.__file = "data-capture-forms.vue"
export default component.exports